// 删除账号建议界面 1

require("clover/panel/component/common/UIGroupButton")

let AccountProposePanel = xClass("AccountProposePanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/logout.pack"
)
AccountProposePanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
AccountProposePanel.preloadResPromise = function(useMask = false) {
    return preloadWithLoadingPromise(RES, useMask)
}
let _instance = null
AccountProposePanel.getInstance = function () {
    let self = this
    return _instance
}
AccountProposePanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self
    self.aManager = AccountManager.getInstance()
    self.aManager.dcProposePanelOpen()
    self.initUI();
}
AccountProposePanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
AccountProposePanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}


AccountProposePanel.prototype.initUI = function () {
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/logout_logout_feedback.csb")
    self.addChild(self.mainNode);

    this.btnClose = self.mainNode.getChildByName("close");
    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        self.aManager.dcProposePanelClick("out")
        this.onClose();
    }, true);

    self.mainNode.getChildByName("txt2").setVisible(false)

    this.btnKefu = self.mainNode.getChildByName("button");
    quickBuildBtn(this.btnKefu, UIGroupButton, PushBounceAnim, () => {
        if (this.isbusy) return
        this.isbusy = true
        self.aManager.dcProposePanelClick("feedback")
        function onFail() {
            Toast.make("打开社区错误，请重试！")
            this.isbusy = false
        }
        if (META.platform == XcloverPlatform.wechatgame) {
            if(mini.openCustomerServiceConversation) {
                this.isbusy = false
                mini.openCustomerServiceConversation();
            } else {
                this.isbusy = false
                Toast.make("您的App版本过低，请升级后重试");
            }
        } else {
            OpenFunscareLogic.openFunscare(1, ()=>{
                this.isbusy = false
            }, null, onFail)
        }
        this.onClose();
    }, true);

    this.btnConfirm = self.mainNode.getChildByName("toast_bg").getChildByName("logout_delete")
    quickBuildBtn(this.btnConfirm, UIGroupButton, PushBounceAnim, () => {
        if (this.isbusy) return
        this.isbusy = true
        self.aManager.dcProposePanelClick("delete")
        self.aManager.showDelTipAgainPanel()
        this.onClose();
        this.isbusy = false
    }, true);
    this.btnKefu.getChildByName("txt").setString("去吐槽")
    
    // let txtString = "亲爱的小村民，您正在进行{c=155,91,63,255/c}账号删除{c=215,42,31,255/c}操作，继续将会导致：\n1.您的{c=155,91,63,255/c}风车币，道具{c=215,42,31,255/c}等物品将会删除  {c=155,91,63,255/c}"
    // let colorLabel= getColorTextH5(txtString,16,24)
    // colorLabel.x = -colorLabel.width/2
    // // colorLabel.y = -colorLabel.height/2
    // colorLabel.y = 90

    // colorLabel.x = -110
    // let contentStr = "如果您对游戏有任何意见和建议，请点击去吐槽按钮，联系我们的工作人员，我们将竭诚为您解决问题。"
    let contentStr = getText("delete.page2.text")
    let contentLable = cc.Label.createWithSystemFont(contentStr, "Arial", 24)
    contentLable.setDimensions(400, 0)
    contentLable.setColor(cc.color(155, 91, 63))
    contentLable.y = 30
    contentLable.setLineHeight(30)
    this.mainNode.addChild(contentLable)

    
}
module.exports = AccountProposePanel